module.exports = __webpack_public_path__ + "static/media/coffee_free_mobile_fr.5d1a39d9.jpg";